<template>
  <div class="settings">
    <br><br>
    <button type="button"
            v-on:click="greetWalterPlugin">Greet Walter Plugin
    </button>
    <br><br>
    <label>
      <input type="number"
             v-model="lat"
             :disabled="gpsTrackingEnabled"
             v-on:change="saveCoordinates">
    </label>
    <br><br>
    <label>
      <input type="number"
             v-model="lng"
             :disabled="gpsTrackingEnabled"
             v-on:change="saveCoordinates">
    </label>
    <br><br>
    <label>
      <input type="checkbox"
             v-model="gpsTrackingEnabled"
             v-on:change="checkLocationTracking"> Location Tracking enabled
    </label>
    <p v-if="successMessage" class="successMessage">{{successMessage}}</p>
  </div>
</template>

<script>
export default {
  components: {},
  created() {
    const coordinates = JSON.parse(localStorage.getItem('Settings::coordinates'));
    if (coordinates != null && typeof coordinates === 'object') {
      this.lat = coordinates.lat;
      this.lng = coordinates.lng;
    }

    const gpsTrackingEnabled = JSON.parse(localStorage.getItem('Settings::gpsTrackingEnabled'));
    if (typeof gpsTrackingEnabled === 'boolean') {
      this.gpsTrackingEnabled = gpsTrackingEnabled;
    }
  },
  data() {
    return {
      gpsTrackingEnabled: false,
      lat: 48.182250,
      lng: 16.319453,
      successMessage: null,
    };
  },
  methods: {
    saveCoordinates() {
      localStorage.setItem('Settings::coordinates', JSON.stringify({
        lat: this.lat,
        lng: this.lng,
      }));
    },
    checkLocationTracking() {
      if (this.gpsTrackingEnabled) {
        walter.startLocationTracking(this.lat, this.lng, (message) => {
          if (message === 'success') {
            this.flashSuccessMessage('gps tracking enabled');
          } else {
            console.error('unable to enable gps tracking', message);
            this.gpsTrackingEnabled = false;
          }
        }, (error) => {
          console.error('unable to enable gps tracking', error);
          this.gpsTrackingEnabled = false;
        });
      } else {
        walter.stopLocationTracking((message) => {
          if (message === 'success') {
            this.flashSuccessMessage('gps tracking disabled');
          } else {
            console.error('unable to disable gps tracking', message);
            this.gpsTrackingEnabled = true;
          }
        }, (error) => {
          console.error('unable to disable gps tracking', error);
          this.gpsTrackingEnabled = true;
        });
      }

      localStorage.setItem('Settings::gpsTrackingEnabled', JSON.stringify(this.gpsTrackingEnabled));
    },
    greetWalterPlugin() {
      walter.greet(
        'Walter App',
        // eslint-disable-next-line no-alert
        message => alert(message),
        error => console.error(error),
      );
    },
    flashSuccessMessage(message) {
      this.successMessage = message;
      setTimeout(() => {
        this.successMessage = null;
      }, 1500);
    },
  },
};
</script>

<style scoped>
.successMessage {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue